import request from '@/utils/request'

export function epms9000paint(param) {
    let data = param
    return request({
        url: `/deliveryReport/epms9000paint/epms9000paint`,
        method: 'POST',
        meta: { apiVersion: '1.0.0' },
        headers: { 'Content-Type': 'application/json;charset=utf8' },
        data
    })
}

export function getShipNoList1(param) {
    let data = param
    return request({
        url: `/deliveryReport/epms9000paint/getShipNoList1`,
        method: 'POST',
        meta: { apiVersion: '1.0.0' },
        headers: { 'Content-Type': 'application/json;charset=utf8' },
        data
    })
}